import { create } from "zustand";
import { useChatStore } from "@/stores/useChatStore";

interface UnsavedChangesGuardState {
	/** 確認ダイアログの返答を待っている呼び出し側。null ならダイアログは閉じている。 */
	pending: ((proceed: boolean) => void) | null;
}

export const useUnsavedChangesGuardStore = create<UnsavedChangesGuardState>(() => ({
	pending: null,
}));

/**
 * チャットの切り替えでファイルタブが閉じる前に、未保存の変更を捨ててよいか確かめる。
 * URL を変える前に呼ぶ。戻る・進む・直リンクでの切り替えは確かめない。
 * 未保存が無ければ確かめずに true を返す。確認中に来た確認は、表示中の確認を優先してキャンセル扱いにする。
 */
export function confirmLeaveWithUnsavedFiles(): Promise<boolean> {
	if (useChatStore.getState().dirtyFileIds.length === 0) return Promise.resolve(true);
	if (useUnsavedChangesGuardStore.getState().pending !== null) return Promise.resolve(false);
	return new Promise((resolve) => {
		useUnsavedChangesGuardStore.setState({ pending: resolve });
	});
}

/** 確認ダイアログの返答を呼び出し側へ返し、ダイアログを閉じる。 */
export function settleUnsavedChangesGuard(proceed: boolean): void {
	const pending = useUnsavedChangesGuardStore.getState().pending;
	useUnsavedChangesGuardStore.setState({ pending: null });
	pending?.(proceed);
}
